import type { Col } from "./types/dataTable.ts";
import { getCols } from "./getCols.ts";

export const getCol = (title: string, overrides?: Partial<Col>): Col => {
	const overrides2 = overrides ? { [title]: overrides } : undefined;
	return getCols([title], overrides2)[0]!;
};
